import { connect } from "react-redux";
import { Link } from "react-router-dom";

var RosterSelectors = require("lib/selectors/RosterSelectors");
var StudentAvatar = require("components/avatars/StudentAvatar");
var GradeLevel = require("lib/academic/GradeLevel");
var Glyphicon = require("components/utility/icons/Glyphicon");

require("users/students/student_display.scss")

@connect(
	(state, props) => {
		var requiredRecords = {
			student: RosterSelectors.student({ state, id: props.studentID })
		}

		if (props.showAvatar) {
			requiredRecords.avatar = RosterSelectors.avatarForStudent(
				{ state, studentID: props.studentID });
		}

		return requiredRecords;
	},

	(dispatch, props) => ({
		// Currently undefined, but we can do this for sure
		// populateData: () => dispatch(RosterActions.batchFetchStudent(props.studentID))
	})
)
class StudentDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		var student = this.props.student;
		var className = "studentDisplay";

		if (!student) {
			// Loading state
			return (
				<div className={ className }>--</div>
			);
		}

		if (this.props.showAvatar && this.props.avatar) {
			className += " nameAndAvatar";
			var avatar = (
				<StudentAvatar student={ student } avatar={ this.props.avatar }
					disableAnimation
					maxHeight={ this.props.avatarMaxHeight }
					maxWidth={ this.props.avatarMaxWidth } />
			);
		}

		if (!this.props.hideName) {
			// if (student.demo_for_teacher) {
			// 	var demoDisplay = (<span> (Demo)</span>);
			// }

			if (this.props.firstNameLastInitial) {
				var name = student.first_name_last_initial;
			} else {
				var name = student.display_name;
			}
		}

		return (
			<div className={ className }>
				{ avatar }
				<span className="textContent">
					<span className="name">
						{ $wr.truncate(name, 20) }
					</span>
				</span>
			</div>
		);
	}

	componentDidMount() {
		// this.props.populateData();
	}
}

StudentDisplay.WrappedComponent.propTypes = StrictPropTypes({
	// ID of the student to be displayed
	studentID: PropTypes.number.isRequired,

	// If set, it will put an avatar (on the left)
	showAvatar: PropTypes.bool,

	// Usually I don't like to have "hide" props, but almost always we want to show the name
	hideName: PropTypes.bool,

	// If set, it will only show the first name, last initial (if set on student)
	firstNameLastInitial: PropTypes.bool,

	// Dimension on the avatar
	avatarMaxWidth: PropTypes.number,
	avatarMaxHeight: PropTypes.number,

	// From @connect
	student: PropTypes.object,
	avatar: PropTypes.object,
	// populateData: PropTypes.func.isRequired

});

module.exports = StudentDisplay


// WEBPACK FOOTER //
// ./modules/components/users/students/StudentDisplay.js